module.exports = __webpack_public_path__ + "img/dialing.c8144854.gif";